import styled from "styled-components";

const OptionsControlButton = ({
  activeIcon,
  inactiveIcon,
  active,
  label,
  devices,
  selectedDevices,
  handleOpenOptionModal,
  ...props
}) => {
  return (
    <Container>
      <Wrapper>
        <CustomButton
          {...props}
          $active={active}
          onClick={handleOpenOptionModal}
        >
          {active ? (
            <ActiveIconWrapper>{activeIcon}</ActiveIconWrapper>
          ) : (
            <InactiveIconWrapper>{inactiveIcon}</InactiveIconWrapper>
          )}
        </CustomButton>
        <CustomLabel>{label}</CustomLabel>
      </Wrapper>
    </Container>
  );
};

export default OptionsControlButton;

const Container = styled.div`
  position: relative;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  min-height: 43px;
  align-items: center;
  gap: 4px;
`;
const CustomButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: none;
  cursor: pointer;
  overflow: hidden;
  background: transparent;
`;

const CustomLabel = styled.label`
  font-size: 10px;
  color: ${({ theme }) => theme.callComponent.controlButtonTextColor};
  line-height: 12px;
  text-align: center;
`;

const ActiveIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  svg {
    color: ${({ theme }) => theme.callComponent.controlButtonBackgroundActive};
    fill: ${({ theme }) => theme.callComponent.controlButtonIconActive};
  }
`;

const InactiveIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  svg {
    color: ${({ theme }) =>
    theme.callComponent.controlButtonBackgroundInactive};
    fill: ${({ theme }) => theme.callComponent.controlButtonIconInactive};
  }
`;
